var map = {
	"./costal-1-2.jpg": "98c5",
	"./costal-2-2.jpg": "b073",
	"./costal-3-2.jpg": "2386",
	"./costal-4-2.jpg": "0eea",
	"./costal-5-2.jpg": "66a5",
	"./costal-6-2.jpg": "42b9",
	"./costal-7-2.jpg": "1611",
	"./costal-8-2.jpg": "4b9e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e31c";